module.exports = __webpack_public_path__ + "static/img/26.e9cf48f9.png";